import {initProcessingLog} from "../../common/voe-orders/initProcessingLog";

function initClientVoeOrdersDetailIndex() {
	// Init log container
	initProcessingLog(document.querySelector('.voe-order-processing-log-container'));

	/**
	 * Methods
	 */
}

export {initClientVoeOrdersDetailIndex}
